import React, { useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { checkOutSelector } from "../../api/checkOutSlice";
import { cartCouponSelector, fetchWalletbalance } from "../../api/cartSlice";
import { loginSelector } from "../../api/authSlice";
import { MdCardGiftcard } from "react-icons/md";
import Payment from "./payment";
import { Checkbox } from "antd";

export default function PaymentMethod() {
  const dispatch = useDispatch();
  const { loading, shippingAdress, vMethod } = useSelector(checkOutSelector);
  const { cartCoupons, total, isUsedWallet, isUsedWalletBallance } =
    useSelector(cartCouponSelector);
  const { curr_user, balance } = useSelector(loginSelector);

  const [c_balance, setC_Balance] = useState(total);

  let b = balance - c_balance;

console.log(c_balance)
  const onChange = (e) => {
    const isChecked = e.target.checked;
    console.log("Checkbox clicked, checked:", isChecked);

    if (isChecked) {
        const remainingBalance = balance - total;
        const walletBalance = remainingBalance > 0 ? 0 : Math.abs(remainingBalance);

        setC_Balance(walletBalance);
        dispatch(fetchWalletbalance({ iswallet: true, b: Math?.abs(remainingBalance) }));
    } 
    else {
        console.log("hjvvcgy")
        setC_Balance(total);
        dispatch(fetchWalletbalance({ iswallet: false, b: 0 }));
    }
};

  return (
    <PlaceOrderWrap className="">
      <div className="row flex gap-[2rem] md:gap[15rem] ">
        <div className="columns-md  ">
          <div className="pl card">
            <h5 style={{ color: "#AF7C5C" }} className="card-header">
              Shipping
            </h5>
            <h6 className="text-dark" style={{ fontSize: "1rem" }}>
              {shippingAdress?.email} <br /> {shippingAdress?.phone_number}
              <br />
              {shippingAdress?.address}
            </h6>
          </div>
          <hr />
          <div className="pl my-8 card">
            <h5 style={{ color: "#AF7C5C" }} className="card-header">
              Order Items
            </h5>
            <div className="container-fluid my-2">
              {cartCoupons.map((item, i) => {
                return (
                  <div
                    className="row align-items-center shadow-sm my-3 py-2"
                    key={i}
                  >
                    <div className="col">
                      <MdCardGiftcard className="bg-dark voucher" />
                      <span className="text-dark" style={{ fontSize: "1rem" }}>
                        <b>{item.name}</b>
                      </span>
                    </div>
                    <div className="col">
                      <h6>
                        {item.qty}&nbsp; x &nbsp;&#x20B9;&nbsp;{item.value}{" "}
                        &nbsp;= &nbsp;&nbsp;&#x20B9;&nbsp;
                        {item.qty * item.value}
                      </h6>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="col-sm-4 w-full md:w-1/3">
  <div className="card shadow-md rounded-lg overflow-hidden">
    <div className="card-header bg-gray-200 p-4">
      <h5 className="font-semibold text-lg">Order Summary</h5>
    </div>
    <ul className="list-group list-group-flush">
      <li className="list-group-item flex justify-between items-center p-4">
        <span className="text-start">Items</span>
        <span className="text-lg font-bold">&#x20B9;&nbsp;{total}</span>
      </li>
      <li className="list-group-item flex justify-between items-center p-4">
        <span>Shipping</span>
        <span>&#x20B9; 0/-</span>
      </li>
      <li className="list-group-item flex justify-between items-center p-4">
        <span>Tax</span>
        <span>&#x20B9; 0/-</span>
      </li>
      <li className="list-group-item flex justify-between items-center p-4 font-semibold">
        <span>Total</span>
        <span className="text-lg">&#x20B9;&nbsp;{total}</span>
      </li>
      <li className="list-group-item">
        <button className="btn btn-dark w-full py-2">
          <Payment
            info={shippingAdress}
            user={curr_user}
            cart={cartCoupons}
            total={total}
            vMethod={vMethod}
            payableAmt={isUsedWalletBallance > 0 ? c_balance : c_balance}
            wallet={isUsedWallet}
          />
        </button>
      </li>
    </ul>

    <div className="px-3 py-2">

    <Checkbox  disabled ={(balance > 0) ? false : true } onChange={onChange}>Use Luova Wallet</Checkbox>

    {
       isUsedWallet &&  <h4 className="pl-4 mt-2">Payable Amount : 	&#8377; {c_balance}</h4>
    }

    {
       isUsedWallet &&  <h4 className="pl-4 mt-2">Availaible bal : 	&#8377; { (c_balance > 0) ? 0 : isUsedWalletBallance}</h4>
    }


</div>
  </div>
</div>


      </div>
    </PlaceOrderWrap>
  );
}

const PlaceOrderWrap = styled.div`
  .voucher {
    font-size: 2rem;
    color: orange;
  }

  .pl {
    h5 {
      text-transform: uppercase;
      font-weight: 400;
      color: #af7c5c;
    }
    h6 {
      font-weight: 400;
      color: grey;
    }
  }

  .card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-top: 20px;
    padding: 15px;

    .card-header {
      background-color: #f8f8f8;
      border-bottom: 1px solid #e0e0e0;
      h5 {
        margin: 0;
        color: #af7c5c;
      }
    }

    .list-group-item {
      border: none;
      padding: 10px;
      &:hover {
        background-color: #f1f1f1;
      }
    }

    button {
      background-color: #af7c5c;
      color: white;
      border: none;
      border-radius: 4px;
      padding: 10px;
      transition: background-color 0.3s;

      &:hover {
        background-color: #9b5a41;
      }
    }
  }

  @media (max-width: 768px) {
    .row {
      flex-direction: column;
      align-items: center;
    }
    .col-sm-8,
    .col-sm-4 {
      width: 100%;
      margin-bottom: 20px;
    }
  }
`;
